import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'

import { makeStyles, styled } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  avatar: {
    marginRight: theme.spacing(1),
    height: '2rem',
    width: '2rem',
  },
}))

export default useStyles

export const LiveEventCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: '1em',
  marginTop: '1em',
}))

export const LiveEventCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  justifyContent: 'space-between',
  '& div.rich-paragraph': {
    margin: 0,
  },
}))

export const LiveEventCardActions = styled(CardActions)(({ theme }) => ({
  padding: theme.spacing(2),
  justifyContent: 'space-between',
}))

export const AuthorContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))
